export default __webpack_public_path__ + "1f35b6b404fc410a2351ea25f2fafc7f.png";